// extracted by css-extract-rspack-plugin
export default {"copyInfo":"_c4ac31f0","copyIcon":"_da3212b5","copyNoir":"_6e9f6424","copyDealer":"_c70dd1a5","iconStart":"_6b75290"};